<div class="p-4 sm:p-6 space-y-4 sm:space-y-6">
  <!-- Header -->
  <div class="flex items-center justify-between gap-3">
    <div class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">Do'kon turlari</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
        Har bir tur uchun mahsulot atributlari avtomatik sozlanadi
      </p>
    </div>
    <div class="flex gap-2 shrink-0">
      <button
        (click)="load()"
        [disabled]="loading()"
        class="p-2 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
      >
        <lucide-icon
          [img]="RefreshCw"
          class="w-4 h-4 text-gray-500"
          [class.animate-spin]="loading()"
        ></lucide-icon>
      </button>
      <button
        (click)="openCreate()"
        class="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium transition-colors"
      >
        <lucide-icon [img]="Plus" class="w-4 h-4"></lucide-icon>
        <span class="hidden sm:inline">Yangi tur</span>
      </button>
    </div>
  </div>

  <!-- Table -->
  @if (loading() && storeTypes().length === 0) {
    <div class="flex justify-center py-16">
      <div
        class="w-8 h-8 border-4 border-gray-200 border-t-green-600 rounded-full animate-spin"
      ></div>
    </div>
  } @else if (storeTypes().length === 0) {
    <div class="flex flex-col items-center justify-center py-16 text-gray-400">
      <lucide-icon [img]="Store" class="w-12 h-12 mb-3"></lucide-icon>
      <p class="text-sm">Hozircha do'kon turlari yo'q</p>
    </div>
  } @else {
    <!-- Mobile card view (hidden on sm+) -->
    <div class="sm:hidden space-y-3">
      @for (st of storeTypes(); track st.id) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 space-y-3"
        >
          <div class="flex items-start justify-between gap-2">
            <div class="flex items-center gap-2 min-w-0">
              <span class="text-lg shrink-0">{{ st.icon || '🏬' }}</span>
              <div class="min-w-0">
                <p class="font-medium text-gray-900 dark:text-gray-100 text-sm truncate">
                  {{ st.name }}
                </p>
                <code
                  class="inline-block mt-0.5 px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 text-xs font-mono"
                  >{{ st.code }}</code
                >
              </div>
            </div>
            <div class="flex items-center gap-1 shrink-0">
              <button
                (click)="openEdit(st)"
                class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
              >
                <lucide-icon [img]="Edit" class="w-4 h-4"></lucide-icon>
              </button>
              <button
                (click)="delete(st.id)"
                class="p-1.5 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors text-gray-500 hover:text-red-600"
              >
                <lucide-icon [img]="Trash2" class="w-4 h-4"></lucide-icon>
              </button>
            </div>
          </div>
          <div class="flex items-center justify-between text-xs">
            <span
              class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold"
              [class]="
                st.isActive
                  ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                  : 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400'
              "
            >
              <lucide-icon
                [img]="st.isActive ? ToggleRight : ToggleLeft"
                class="w-3 h-3"
              ></lucide-icon>
              {{ st.isActive ? 'Faol' : 'Nofaol' }}
            </span>
            <span class="text-gray-400">{{ st.createdAt | date: 'dd.MM.yyyy' }}</span>
          </div>
        </div>
      }
    </div>

    <!-- Desktop table view (hidden on mobile) -->
    <div
      class="hidden sm:block rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
    >
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr
              class="border-b border-gray-100 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-900/50"
            >
              <th
                class="px-4 py-3 text-left font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap"
              >
                Nomi
              </th>
              <th
                class="px-4 py-3 text-left font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap"
              >
                Kod
              </th>
              <th
                class="px-4 py-3 text-left font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap"
              >
                Ikonka
              </th>
              <th
                class="px-4 py-3 text-left font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap"
              >
                Holat
              </th>
              <th
                class="px-4 py-3 text-left font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap"
              >
                Yaratilgan
              </th>
              <th class="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            @for (st of storeTypes(); track st.id) {
              <tr
                class="border-b border-gray-50 dark:border-gray-800/50 hover:bg-gray-50/50 dark:hover:bg-gray-800/30 transition-colors"
              >
                <td
                  class="px-4 py-3 font-medium text-gray-900 dark:text-gray-100 whitespace-nowrap"
                >
                  {{ st.name }}
                </td>
                <td class="px-4 py-3">
                  <code
                    class="px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 text-xs font-mono"
                    >{{ st.code }}</code
                  >
                </td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400">{{ st.icon || '—' }}</td>
                <td class="px-4 py-3">
                  <span
                    class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold"
                    [class]="
                      st.isActive
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                        : 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400'
                    "
                  >
                    <lucide-icon
                      [img]="st.isActive ? ToggleRight : ToggleLeft"
                      class="w-3 h-3"
                    ></lucide-icon>
                    {{ st.isActive ? 'Faol' : 'Nofaol' }}
                  </span>
                </td>
                <td class="px-4 py-3 text-gray-400 text-xs whitespace-nowrap">
                  {{ st.createdAt | date: 'dd.MM.yyyy' }}
                </td>
                <td class="px-4 py-3">
                  <div class="flex items-center gap-1 justify-end">
                    <button
                      (click)="openEdit(st)"
                      class="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                    >
                      <lucide-icon [img]="Edit" class="w-4 h-4"></lucide-icon>
                    </button>
                    <button
                      (click)="delete(st.id)"
                      class="p-1.5 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors text-gray-500 hover:text-red-600"
                    >
                      <lucide-icon [img]="Trash2" class="w-4 h-4"></lucide-icon>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>

<!-- Create / Edit Dialog -->
@if (dialogOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <!-- eslint-disable-next-line -->
    <div class="absolute inset-0 bg-black/50" (click)="closeDialog()"></div>
    <div class="relative bg-white dark:bg-gray-900 rounded-xl shadow-lg w-full max-w-md">
      <div
        class="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-gray-800"
      >
        <h2 class="font-semibold text-gray-900 dark:text-gray-100">
          {{ isEditMode ? "Do'kon turini tahrirlash" : "Yangi do'kon turi" }}
        </h2>
        <button
          (click)="closeDialog()"
          class="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
        >
          <lucide-icon [img]="X" class="w-5 h-5 text-gray-400"></lucide-icon>
        </button>
      </div>

      <div class="p-6 space-y-4">
        <!-- Name -->
        <div class="flex flex-col gap-1.5">
          <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300"
            >Nomi <span class="text-red-500">*</span></label
          >
          <input
            [(ngModel)]="form.name"
            placeholder="Kiyim-kechak do'koni"
            class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
          />
        </div>

        <!-- Code (create only) -->
        @if (!isEditMode) {
          <div class="flex flex-col gap-1.5">
            <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300"
              >Kod <span class="text-red-500">*</span></label
            >
            <input
              [(ngModel)]="form.code"
              placeholder="clothing"
              class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm font-mono focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
            />
            <p class="text-xs text-gray-400">
              Faqat kichik lotin harflari va tire (-). Masalan: clothing, electronics
            </p>
          </div>
        }

        <!-- Icon -->
        <div class="flex flex-col gap-1.5">
          <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300"
            >Ikonka (emoji)</label
          >
          <input
            [(ngModel)]="form.icon"
            placeholder="👔"
            class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
          />
        </div>

        <!-- IsActive (edit only) -->
        @if (isEditMode) {
          <div class="flex items-center gap-2">
            <input
              type="checkbox"
              id="stIsActive"
              [(ngModel)]="form.isActive"
              class="w-4 h-4 text-green-600 border-gray-300 rounded"
            />
            <label for="stIsActive" class="text-sm font-medium text-gray-700 dark:text-gray-300"
              >Faol</label
            >
          </div>
        }
      </div>

      <div class="flex justify-end gap-2 px-6 py-4 border-t border-gray-100 dark:border-gray-800">
        <button
          type="button"
          (click)="closeDialog()"
          class="px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-800 text-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
        >
          Bekor
        </button>
        <button
          type="button"
          (click)="save()"
          [disabled]="submitting() || !form.name.trim() || (!isEditMode && !form.code.trim())"
          class="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium transition-colors disabled:opacity-50"
        >
          {{ submitting() ? 'Saqlanmoqda...' : 'Saqlash' }}
        </button>
      </div>
    </div>
  </div>
}
